'use client';

import { ThirdPartyButton } from 'swp-react';
import AddFacebookButtonStyle from './AddFacebookButton.module.scss';
import { fbLogin, getFacebookLoginStatus } from '@/utils/facebook';
import { useRouter } from 'next/router';
import { logToAi } from '@/utils/logging';

const AddFacebookButton = () => {
	const router = useRouter();

	const onClick = () => {
		logToAi(
			{
				message: `AddFacebookButton pressed!`,
				id: 'ADD_FACEBOOK_BUTTON_PRESS',
				location: 'AddFacebookButton.jsx:onClick',
			}, 
			'debug'
		);

		/**
		 * If the fb account has 2fa, you need to click the facebook twice if
		 * you are logging in for the first time in that browser. This is
		 * because fb resolves the promise for fbLogin before the user confirms
		 * the 2fa. This is a limitation of the sdk. I tried adding a
		 * setInterval that checked the login status, but even that never
		 * shows a "connected" status.
		 */
		getFacebookLoginStatus().then((response) => {
			if (response.status === 'connected') {
				router.push('/facebook');
			} else {
				fbLogin().then((response) => {
					if (response.status === 'connected') {
						router.push('/facebook');
					} else {
						console.warn('login unsuccessful');
					}
				});
			}
		});
	};

	return (
		<ThirdPartyButton
			className={AddFacebookButtonStyle['add-facebook-button']}
			height="56px"
			width={'100%'}
			onClick={onClick}
		>
			<img src="/images/icon_img-upload_fb.png" alt="" />
			<span className="text">Add from Facebook</span>
		</ThirdPartyButton>
	);
};

AddFacebookButton.displayName = 'AddFacebookButton';
export default AddFacebookButton;
